import { render, staticRenderFns } from "./RvFws2024View.vue?vue&type=template&id=8a0754dc&scoped=true&"
import script from "./RvFws2024View.vue?vue&type=script&lang=js&"
export * from "./RvFws2024View.vue?vue&type=script&lang=js&"
import style0 from "./RvFws2024View.vue?vue&type=style&index=0&id=8a0754dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0754dc",
  null
  
)

export default component.exports